import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  AnnouncementDetails,
  AnnouncementDetailsVariables
} from "./types/AnnouncementDetails";
import {
  AnnouncementList,
  AnnouncementListVariables
} from "./types/AnnouncementList";

export const announcementList = gql`
  ${pageInfoFragment}
  query AnnouncementList(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $filter: AnnouncementInput
    $sortBy: AnnouncementSortingInput
  ) {
    announcements(
      after: $after
      before: $before
      first: $first
      last: $last
      filter: $filter
      sortBy: $sortBy
    ) {
      edges {
        node {
          id
          title
          content
          startDate
          endDate
          image {
            url
          }
          publishingStatus
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
  }
`;
export const useAnnouncementListQuery = makeQuery<
  AnnouncementList,
  AnnouncementListVariables
>(announcementList);

export const announcementDetails = gql`
  query AnnouncementDetails($id: ID!) {
    announcement(id: $id) {
      id
      image {
        url
        alt
      }
      title
      content
      startDate
      endDate
      publishingStatus
    }
  }
`;
export const useAnnouncementDetailsQuery = makeQuery<
  AnnouncementDetails,
  AnnouncementDetailsVariables
>(announcementDetails);
